import { Business } from "@/components/landing/Business";

export default function BusinessPage() {
  return (
    <div data-testid="business-page">
      <Business />
    </div>
  );
}
